var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useSession } from '@lendi/lala-react';
import { Text } from '@lendi/ui/Typography';
import React, { useEffect, useState } from 'react';
import { getThreads } from '../../apis/getThreads';
import { useError } from '../../providers/ErrorProvider/context';
import { StyledLink, UnreadCount, Wrapper } from './style';
var REFRESH_TIMEOUT_MS = 30 * 1000;
export var StatusBar = function (_a) {
    var currentThread = _a.currentThread, showThreadsPanel = _a.showThreadsPanel;
    var _b = useState({ threads: [] }), otherThreadsResponse = _b[0], setOtherThreadsResponse = _b[1];
    var _c = useState(0), unReadMessageCount = _c[0], setUnReadMessageCount = _c[1];
    var _d = useState(''), unreadMessage = _d[0], setUnreadMessage = _d[1];
    var session = useSession();
    var onException = useError().onException;
    useEffect(function () {
        var getMessagesStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
            var threads, otherThreads;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getThreads(session, onException)];
                    case 1:
                        threads = (_a.sent()).threads;
                        otherThreads = threads.filter(function (t) { return t.userGroupHash !== currentThread; });
                        setOtherThreadsResponse({ threads: otherThreads });
                        return [2 /*return*/];
                }
            });
        }); };
        getMessagesStatus();
        var timerId = setInterval(getMessagesStatus, REFRESH_TIMEOUT_MS);
        return function () {
            clearTimeout(timerId);
        };
    }, []);
    useEffect(function () {
        var noOfUnreadMessages = otherThreadsResponse.threads.reduce(function (total, thread) { return total + thread.unreadMessageCount; }, 0);
        setUnReadMessageCount(noOfUnreadMessages);
    }, [otherThreadsResponse]);
    useEffect(function () {
        var noOfOtherThreads = otherThreadsResponse.threads.length;
        if (unReadMessageCount > 0) {
            var dynamicVariable1 = unReadMessageCount > 1 ? "Messages" : 'Message';
            var dynamicVariable2 = noOfOtherThreads > 1 ? "other threads" : 'another thread';
            var message = "New ".concat(dynamicVariable1, " on ").concat(dynamicVariable2);
            setUnreadMessage(message);
        }
    }, [unReadMessageCount, otherThreadsResponse]);
    return otherThreadsResponse.threads.length >= 1 ? (React.createElement(Wrapper, { highlighted: unReadMessageCount > 0 }, unReadMessageCount > 0 ? (React.createElement(React.Fragment, null,
        React.createElement(UnreadCount, null, unReadMessageCount),
        React.createElement(Text, { variant: "body2", tag: "span", isInverse: unReadMessageCount > 0 },
            unreadMessage,
            " ",
            ' - ',
            React.createElement(StyledLink, { onClick: showThreadsPanel }, "Click here")))) : (React.createElement(Text, { variant: "body2", tag: "span" },
        "There are multiple threads ",
        ' - ',
        React.createElement(StyledLink, { onClick: showThreadsPanel }, "View threads"))))) : (React.createElement(React.Fragment, null));
};
//# sourceMappingURL=index.js.map